<template>
  <div>
    <div>
      <el-page-header @back="goBack" content="考试详情" style="margin-bottom: 10px">
      </el-page-header>
    </div>
    <div style="margin: 10px 0">
      <el-row>
        <el-col :span="6"><b>考试：{{this.examInfo.name}} </b></el-col>
        <el-col :span="6"> <b>考试项目：{{this.$route.query.subject}}</b></el-col>
        <el-col :span="6"><b>考试时间：{{this.examInfo.begin_dt}}~{{this.examInfo.end_dt}} </b></el-col>
        <el-col :span="6"><b>限时：{{this.tableData[0].mins}}分钟</b></el-col>
      </el-row>
    </div>
    <el-table border :data="tableData" stripe style="width: 100%">
      <el-table-column   label="序号">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column prop="student_name" label="考生" >
      </el-table-column>
      <el-table-column prop="exam_result_begin" label="考试时间" >
      </el-table-column>
      <el-table-column prop="exam_result_time" label="耗时" >
      </el-table-column>
      <el-table-column prop="exam_result_score" label="	成绩" >
      </el-table-column>
      <el-table-column prop="teachers" label="评价老师" >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="small"  @click="handleEdit(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page" @pagination="getData"/>

    </div>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        components: { Pagination },
  props: {

  },
  data() {
    return {
        total:0,
        dialogType:'new',
        dialogVisible:false,
        tableData: [],
        examInfo:{},
        listQuery: {
            page: 1,
            per_page:20
        },
    };
  },
  computed: {

  },
  created() {
    this.getData();
  },
  methods: {
      goBack(){
          this.$router.back();
      },
    getData() {
      this.$http.getSubjectScoreDetail( this.$route.query)
        .then(res => {
          this.tableData = res.data.data.data;
            this.total = res.data.data.total;
            this.examInfo = res.data.examInfo;

        })
        .catch(err => {
          console.log(err);
        })
    },
      handleEdit(scope) {
        this.$router.push({name:'scoreResult',query:{id:scope.exam_result_id}})
      },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/subjectScoreDetail.vue